import clsx from 'clsx';
import { useCallback, useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { Modal } from 'react-bootstrap-v5';
import Select from 'react-select';
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import { PageTitle, useLayout } from "../../../_metronic/layout/core";
import { IEmpresas } from "../../interfaces/IEmpresas";
import { IRegimeTributario } from "../../interfaces/IRegimeTributario";
import EmpresasService from "../../services/EmpresasService";
import RegimeTributarioService from "../../services/RegimeTributarioService";
import EmpresasModal from "../empresas/EmpresasModal";
// @ts-check
// @ts-ignore
import planoNovaService from '../../services/planoNovaService';
import { uniqueId } from 'lodash';
import empresaNovaService from '../../services/empresaNovaService';
import api from '../../services/Api';
import axios from 'axios';
import { IUpload } from '../../interfaces/IUpload';
import { IEcdValidacaoResultado, IEcdZipValidacaoResultado } from '../../interfaces/IEcdValidacao';
import UploadService from '../../services/UploadService';

/*Tradução */
import './../../../i18n/config';
import { useTranslation } from 'react-i18next';

const steps = {
    0: { name: 'ECD', enabled: true, id: 0 },
}

function formatarTamanhoArquivo(bytes: number): string {
    if (!bytes || bytes <= 0) return '-';
    const unidades = ['B', 'KB', 'MB', 'GB'];
    let valor = bytes;
    let i = 0;
    while (valor >= 1024 && i < unidades.length - 1) {
        valor /= 1024;
        i++;
    }
    return `${valor.toFixed(valor >= 10 || i === 0 ? 0 : 1)} ${unidades[i]}`;
}

function formatarDuracao(ms: number): string {
    if (!ms || ms <= 0) return '-';
    const totalSegundos = Math.round(ms / 1000);
    const horas = Math.floor(totalSegundos / 3600);
    const minutos = Math.floor((totalSegundos % 3600) / 60);
    const segundos = totalSegundos % 60;
    if (horas > 0) return `${horas}h ${minutos}min`;
    if (minutos > 0) return `${minutos}min ${segundos}s`;
    return `${segundos}s`;
}

function formatarDataResumo(data: string | null): string {
    if (!data) return '-';
    return new Date(data).toLocaleDateString('pt-BR');
}

const EmpresaCol = ({ empresa, regimes, regimeSelecionado, setEmpresa }: { empresa: IEmpresas | null, regimes: IRegimeTributario[], regimeSelecionado: string, setEmpresa: Function }) => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const { t } = useTranslation();
    async function toggleModal(carregarEmpresa?: boolean): Promise<void> {
        let show = !showModal;
        setShowModal(show);

        if (show === false) {
            if (carregarEmpresa && empresa) {
                const result = await EmpresasService.obterPorId(empresa.id);
                setEmpresa(result);
            }
        }
    }

    return (
        <div className="col-md-12">
            {
                empresa &&
                <>
                    <label style={{ fontSize: '0.875em', color: '#aaa' }}>{t("Razão Social")}</label>
                    <h3>{empresa.nomeFantasia || empresa.razaoSocial}</h3>
                    <label style={{ fontSize: '0.875em', color: '#aaa' }}>{t('CNPJ')}</label>
                    <h3>{empresa.cnpj || 'CNPJ não foi importado'}</h3>
                    <label style={{ fontSize: '0.875em', color: '#aaa' }}>{t("Regime Tributário")}</label>
                    <h3>{regimes.find(r => r.id === parseInt(regimeSelecionado))?.nome || "Regime não encontrado"}</h3>

                    <EmpresasModal empresa={empresa} title="Empresa" show={showModal} toggleModal={toggleModal} />
                </>
            }
        </div>
    )
}

const formatarCnpj = (cnpj?: string): string => {
    if (!cnpj) return '';
    const num = cnpj.replace(/\D/g, '');
    if (num.length === 14) {
        return num.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    }
    return cnpj;
};

// Converte de ISO (yyyy-MM-dd, formato nativo do <input type="date">) para dd/MM/yyyy,
// formato que o backend espera dentro da string "periodo" (ex: "01/01/2024 a 31/12/2024").
const isoParaDataBr = (iso?: string): string => {
    if (!iso) return '';
    const [ano, mes, dia] = iso.split('-');
    return ano && mes && dia ? `${dia}/${mes}/${ano}` : iso;
};

// @ts-check
// @ts-ignore
const ImportarECD = ({ file, empresa, regimeSelecionado, tituloImportacao, setFazendoImportacao, setFile, setEmpresa, fazendoImportacao, setRegimeSelecionado, regimes, setTipoArquivo }: { regimes: IRegimeTributario[], regimeSelecionado: string, setFazendoImportacao: Function, tituloImportacao: string, setRegimeSelecionado: Function, file: File | null, empresa: IEmpresas | null, setFile: Function, setEmpresa: Function, fazendoImportacao: boolean, setTipoArquivo: Function }) => {
    const history = useHistory();
    const [empresas, setEmpresas] = useState<any>();
    const [lendoArquivo, setLendoArquivo] = useState<boolean>(false);
    const [uploadProgress, setUploadProgress] = useState<number>(0);
    const [plano, setPlano] = useState<any>('');
    const [planosEncontrados, setPlanosEncontrados] = useState<any[]>([]);
    const [tipo, setTipo] = useState('');
    const [empresaSelecionada, setEmpresaSelecionada] = useState<any>();
    const [dataInicial, setDataInicial] = useState<string>();
    const [dataFinal, setDataFinal] = useState<string>();
    const [uploads, setUploads] = useState<IUpload[]>([]);
    const [carregandoUploads, setCarregandoUploads] = useState<boolean>(false);
    const [uploadSelecionado, setUploadSelecionado] = useState<IUpload | null>(null);
    const [showStatusModal, setShowStatusModal] = useState<boolean>(false);
    const [baixando, setBaixando] = useState<number | null>(null);
    const [validandoEcd, setValidandoEcd] = useState<boolean>(false);
    const [resultadoValidacao, setResultadoValidacao] = useState<IEcdValidacaoResultado | null>(null);
    const [resultadoValidacaoZip, setResultadoValidacaoZip] = useState<IEcdZipValidacaoResultado | null>(null);
    const [arquivoValidado, setArquivoValidado] = useState<{ generatedFileName: string, originalFileName: string } | null>(null);
    const [showValidacaoModal, setShowValidacaoModal] = useState<boolean>(false);
    const [enviandoEcd, setEnviandoEcd] = useState<boolean>(false);
    const [pularValidacaoEcd, setPularValidacaoEcd] = useState<boolean>(false);
    const { t } = useTranslation();

    useEffect(() => {
        const load = async () => {
            const r = await empresaNovaService.buscar();
            setEmpresas(r);
        }

        load();
    }, [])

    // CNPJ na frente da razão social — facilita achar a empresa certa quando há nomes
    // parecidos/duplicados, e evita depender só do nome (que pode ficar cortado no select).
    const empresaOptions = useMemo(() => {
        return (empresas || []).map((x: IEmpresas) => ({
            value: x.id,
            label: `${formatarCnpj(x.cnpj)} - ${x.razaoSocial || x.nomeFantasia || ''}`
        }));
    }, [empresas]);

    async function handleFileUpload(file: File) {
        setLendoArquivo(true);
        setUploadProgress(0);

        try {
            // 1. Solicitar URL assinada
            const { data: uploadUrlData } = await api.post(`/Upload/generate-url`, {
                originalFileName: file.name,
                contentType: file.type || 'application/octet-stream'
            });

            const { signedUrl, generatedFileName } = uploadUrlData;

            // 2. Fazer o PUT para a URL da Google (usando axios puro para evitar interceptores da nossa api)
            await axios.put(signedUrl, file, {
                headers: {
                    'Content-Type': file.type || 'application/octet-stream'
                },
                onUploadProgress: (progressEvent) => {
                    const progress = Math.round((progressEvent.loaded * 100) / (progressEvent.total ?? 1));
                    setUploadProgress(progress);
                }
            });

            const ehZip = file.name.toLowerCase().endsWith('.zip');

            // 3. Notificar conclusão do upload
            if (tipo === 'ecd' && !pularValidacaoEcd) {
                // Antes de disparar o processamento, valida o arquivo já enviado ao bucket e
                // aguarda a confirmação do usuário no modal de resultado da validação.
                // Um .zip é uma leva de ECDs a consolidar numa esteira só — validação e modal próprios.
                setValidandoEcd(true);
                try {
                    if (ehZip) {
                        const { data: validacaoZip } = await api.post<IEcdZipValidacaoResultado>(`/ecd/validar`, {
                            generatedFileName: generatedFileName,
                            originalFileName: file.name
                        });
                        setResultadoValidacaoZip(validacaoZip);
                        setResultadoValidacao(null);
                    } else {
                        const { data: validacao } = await api.post<IEcdValidacaoResultado>(`/ecd/validar`, {
                            generatedFileName: generatedFileName,
                            originalFileName: file.name
                        });
                        setResultadoValidacao(validacao);
                        setResultadoValidacaoZip(null);
                    }
                    setArquivoValidado({ generatedFileName, originalFileName: file.name });
                    setShowValidacaoModal(true);
                } catch (errorValidacao) {
                    console.error('Erro ao validar arquivo ECD:', errorValidacao);
                    Swal.fire({
                        text: t('Erro ao validar o arquivo. Tente novamente.'),
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                } finally {
                    setValidandoEcd(false);
                }

                setLendoArquivo(false);
                return;
            } else if (tipo === 'ecd' && pularValidacaoEcd) {
                // Usuário optou por pular a validação prévia — dispara a importação direto.
                await api.post(`/ecd`, {
                    generatedFileName: generatedFileName,
                    originalFileName: file.name
                });
            } else if (tipo.startsWith('razao-')) {
                const razaoBody: any = {
                    generatedFileName: generatedFileName,
                    originalFileName: file.name,
                    tipo: tipo
                };
                if (tipo === 'razao-padrao-participante' && empresaSelecionada) {
                    razaoBody.empresaId = empresaSelecionada;
                }
                if (tipo === 'razao-winthor') {
                    if (empresaSelecionada) razaoBody.empresaId = empresaSelecionada;
                    if (dataInicial && dataFinal) razaoBody.periodo = `${isoParaDataBr(dataInicial)} a ${isoParaDataBr(dataFinal)}`;
                }
                if (tipo === 'razao-protheus') {
                    if (empresaSelecionada) razaoBody.empresaId = empresaSelecionada;
                    if (dataInicial && dataFinal) razaoBody.periodo = `${isoParaDataBr(dataInicial)} a ${isoParaDataBr(dataFinal)}`;
                }
                await api.post(`/razao`, razaoBody);
            }

            setLendoArquivo(false);
            
            Swal.fire({
                text: t('Arquivo enviado com sucesso'),
                icon: 'success',
                timer: 3000,
                showConfirmButton: false
            });

        } catch (error) {
            console.error('Erro no upload:', error);
            setLendoArquivo(false);
            
            Swal.fire({
                text: t('Erro ao enviar o arquivo'),
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    }

    useEffect(() => {
        const buscar = async () => {
            const planos = await planoNovaService.buscar()
            if (planos.length > 0) {
                if (planos.length == 1)
                    setPlano(planos[0].nome);

                setPlanosEncontrados(planos);
            } else {
                Swal.fire({
                    text: t("Por favor contate o suporte para vincular um plano ao seu cadastro."),
                    timer: 400000,
                    icon: 'error',
                    showConfirmButton: false
                });
            }
        }

        buscar()
    }, []);

    const fetchUploads = useCallback(async () => {
        setCarregandoUploads(true);
        try {
            const result = await UploadService.obterTodos(0, 10);
            setUploads(result.data);
        } catch (error) {
            console.error("Erro ao carregar uploads:", error);
        } finally {
            setCarregandoUploads(false);
        }
    }, []);

    useEffect(() => {
        fetchUploads();
        const interval = setInterval(fetchUploads, 5000); // Poll every 5 seconds
        return () => clearInterval(interval);
    }, [fetchUploads]);

    const handleDownload = useCallback(async (upload: IUpload) => {
        setBaixando(upload.id);
        try {
            const url = await UploadService.obterUrlDownload(upload.id);
            const link = document.createElement('a');
            link.href = url;
            link.download = upload.nomeOriginal;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch {
            Swal.fire({
                text: t('Erro ao gerar link de download. Tente novamente.'),
                icon: 'error',
                timer: 3000,
                showConfirmButton: false
            });
        } finally {
            setBaixando(null);
        }
    }, [t]);

    const confirmarImportacaoEcd = useCallback(async () => {
        if (!arquivoValidado) return;
        setEnviandoEcd(true);
        try {
            await api.post(`/ecd`, {
                generatedFileName: arquivoValidado.generatedFileName,
                originalFileName: arquivoValidado.originalFileName
            });
            setShowValidacaoModal(false);
            setResultadoValidacao(null);
            setResultadoValidacaoZip(null);
            setArquivoValidado(null);
            Swal.fire({
                text: t('Arquivo enviado com sucesso'),
                icon: 'success',
                timer: 3000,
                showConfirmButton: false
            });
        } catch (error) {
            console.error('Erro ao iniciar importação do ECD:', error);
            Swal.fire({
                text: t('Erro ao enviar o arquivo'),
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            setEnviandoEcd(false);
        }
    }, [arquivoValidado, t]);

    const cancelarValidacaoEcd = useCallback(() => {
        setShowValidacaoModal(false);
        setResultadoValidacao(null);
        setResultadoValidacaoZip(null);
        setArquivoValidado(null);
    }, []);

    return (
        <div className="col-md-12">
            {
                !fazendoImportacao &&
                (
                    <>
                        {
                            planosEncontrados.length > 1 && (
                                <div style={{ width: '200px', margin: '0 auto', marginBottom: '12px' }}>
                                    <select onChange={e => {
                                        const v = e.target.value;
                                        setPlano(v);
                                    }} disabled={lendoArquivo} value={plano} style={{ backgroundColor: 'white' }} placeholder={t("Selecione um plano")} className="form-select" id="form-mensagem-item-tipo">
                                        <option value="" className="form-label">{t('Plano')}</option>
                                        {planosEncontrados.map((item) => (
                                            <option key={uniqueId()} value={item.nome}>{item.nome}</option>
                                        ))}
                                    </select>
                                </div>
                            )
                        }
                        <div style={{ width: '200px', margin: '0 auto' }}>
                            <select onChange={e => {
                                const v = e.target.value;
                                setTipoArquivo(v);
                                setTipo(v);
                                setEmpresa("")
                                setDataInicial("")
                                setDataFinal("")
                            }} disabled={lendoArquivo} style={{ backgroundColor: 'white' }} placeholder={t('Selecione')} className="form-select" id="form-mensagem-item-tipo">
                                <option value="" className="form-label">{t('Tipo de arquivo')}</option>
                                <option value="ecd" className="form-label">ECD (.txt ou .zip com vários ECDs)</option>
                                <option value="razao-padrao" className="form-label">{t('Razão Contábil')} - Padrão AgHolmes</option>
                                <option value="razao-padrao-participante" className="form-label">{t('Razão Contábil')} - Padrão AgHolmes (Participante)</option>
                                <option value="razao-dominio" className="form-label">{t('Razão Contábil')} - Domínio</option>
                                <option value="razao-wkradar" className="form-label">{t('Razão Contábil')} - WKRadar</option>
                                <option value="razao-protheus" className="form-label">{t('Razão Contábil')} - Protheus</option>
                                <option value="razao-protheusrm" className="form-label">{t('Razão Contábil')} - Protheus RM</option>
                                <option value="razao-questor" className="form-label">{t('Razão Contábil')} - Questor</option>
                                <option value="razao-contimatique" className="form-label">{t('Razão Contábil')} - Contmatic</option>
                                <option value="razao-tasy" className="form-label">{t('Razão Contábil')} - Tasy</option>
                                <option value="razao-fortes" className="form-label">{t('Razão Contábil')} - Fortes</option>
                                <option value="razao-jbsoftwaretxt" className="form-label">{t('Razão Contábil')} - JD Software (Txt)</option>
                                <option value="razao-mxm" className="form-label">{t('Razão Contábil')} - Mxm</option>
                                <option value="razao-sankhya" className="form-label">{t('Razão Contábil')} - Sankhya</option>
                                <option value="razao-calima" className="form-label">{t('Razão Contábil')} - Calima</option>
                                <option value="razao-piramide" className="form-label">{t('Razão Contábil')} - Pirâmide</option>
                                <option value="razao-piramidebalancete" className="form-label">{t('Razão Contábil')} - Pirâmide (Balancete)</option>
                                <option value="razao-makrosystem" className="form-label">{t('Razão Contábil')} - Makrosystem</option>
                                <option value="razao-nasajon" className="form-label">{t('Razão Contábil')} - Nasajon</option>
                                <option value="razao-sap" className="form-label">{t('Razão Contábil')} - SAP</option>
                                <option value="razao-winthor" className="form-label">{t('Razão Contábil')} - WinThor (TOTVS)</option>
                                <option value="razao-momentum" className="form-label">{t('Razão Contábil')} - SCK</option>
                                <option value="razao-personalizado" className="form-label">{t('Razão Contábil')} - Personalizado</option>
                                <option value="razao-sencinet" className="form-label">{t('Razão Contábil')} - Sencinet</option>
                                <option value="razao-veronese" className="form-label">{t('Razão Contábil')} - Protheus VRN</option>
                                <option value="razao-sageiob" className="form-label">{t('Razão Contábil')} - IOB</option>
                                <option value="razao-senior" className="form-label">{t('Razão Contábil')} - Sênior</option>
                                <option value="razao-alterdata" className="form-label">{t('Razão Contábil')} - AlterData</option>
                                <option value="razao-exactus" className="form-label">{t('Razão Contábil')} - Exactus</option>
                                <option value="razao-mastermaq" className="form-label">{t('Razão Contábil')} - Mastermaq</option>
                                <option value="razao-mastermaq" className="form-label">{t('Razão Contábil')} - Mastermaq</option>
                                <option value="ct2" className="form-label">CT2</option>
                            </select >
                        </div >
                        {
                            tipo === 'ecd' && (
                                <div className="form-check" style={{ width: '260px', margin: '12px auto 0' }}>
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="pular-validacao-ecd"
                                        checked={pularValidacaoEcd}
                                        disabled={lendoArquivo}
                                        onChange={e => setPularValidacaoEcd(e.target.checked)}
                                    />
                                    <label className="form-check-label" htmlFor="pular-validacao-ecd" style={{ fontSize: '0.875em' }}>
                                        {t("Pular validação prévia e importar diretamente")}
                                    </label>
                                </div>
                            )
                        }
                        <div style={{ width: '200px', margin: '0 auto', marginTop: '12px' }}>
                            <select onChange={e => {
                                setRegimeSelecionado(e.target.value)
                            }} disabled={lendoArquivo} style={{ backgroundColor: 'white' }} placeholder={t("Selecione")} className="form-select" id="form-mensagem-item">
                                <option value="" className="form-label">{t('Regime Tributario')}</option>
                                {
                                    regimes.map((x, index) => <option key={index} value={x.id} className="form-label">{x.nome}</option>)
                                }
                            </select>
                        </div>
                        {
                            // razao-padrao-participante: empresa obrigatória (período vem das datas do arquivo)
                            tipo === "razao-padrao-participante" && (
                                <div style={{ width: '100%', maxWidth: '520px', margin: '0 auto', marginTop: '12px', padding: '0 12px' }}>
                                    <Select
                                        inputId="form-empresa-participante"
                                        classNamePrefix="react-select"
                                        isDisabled={lendoArquivo}
                                        isLoading={!empresas}
                                        options={empresaOptions}
                                        value={empresaOptions.find((opt: any) => opt.value === empresaSelecionada) ?? null}
                                        onChange={(selected: any) => setEmpresaSelecionada(selected?.value)}
                                        placeholder={t("Selecione a Empresa")}
                                        noOptionsMessage={() => t("Nenhuma empresa encontrada")}
                                        isClearable
                                    />
                                </div>
                            )
                        }
                        {
                            // outros tipos que precisam de empresa + período manual
                            (tipo === "razao-contimatique" || tipo === "razao-tasy" || tipo === "razao-protheus" || tipo === "razao-protheusrm" || tipo === "razao-sankhya" || tipo === "razao-calima" || tipo === "razao-momentum" || tipo === "razao-makrosystem" || tipo === "razao-personalizado" || tipo === "razao-veronese" || tipo === "razao-sencinet" || tipo === "razao-exactus" || tipo === "razao-mastermaq" || tipo === "razao-winthor") && (
                                <>
                                    <div style={{ width: '100%', maxWidth: '520px', margin: '0 auto', marginTop: '12px', padding: '0 12px' }}>
                                        <Select
                                            inputId="form-empresa-razao"
                                            classNamePrefix="react-select"
                                            isDisabled={lendoArquivo}
                                            isLoading={!empresas}
                                            options={empresaOptions}
                                            value={empresaOptions.find((opt: any) => opt.value === empresaSelecionada) ?? null}
                                            onChange={(selected: any) => setEmpresaSelecionada(selected?.value)}
                                            placeholder={t("Selecione a Empresa")}
                                            noOptionsMessage={() => t("Nenhuma empresa encontrada")}
                                            isClearable
                                        />
                                    </div>
                                    <div style={{ width: '100%', maxWidth: '320px', margin: '0 auto', marginTop: '12px' }}>
                                        <label htmlFor="data-inicial-razao">{t("Período")}</label>
                                        <input id="data-inicial-razao" type="date" className='form-control' value={dataInicial ?? ''} onChange={(e) => setDataInicial(e.target.value)} />
                                        <label htmlFor="data-final-razao" style={{ width: '100%', textAlign: 'center', marginTop: '12px' }}>{t("Até")}</label>
                                        <input id="data-final-razao" type="date" className='form-control' value={dataFinal ?? ''} onChange={(e) => setDataFinal(e.target.value)} />
                                    </div>
                                </>
                            )
                        }
                    </>
                )
            }

            <>
                <input style={{ display: 'none' }} id="inputFile" type="file"
                    accept={tipo === 'ecd' ? '.txt,.zip' : undefined}
                    onChange={(e) => {
                        if (e.target.files !== null && e.target.files.length > 0) {
                            handleFileUpload(e.target.files[0]);
                        }
                    }} />
                <div onClick={() => {
                    if (!tipo) {
                        Swal.fire({
                            text: t("Por favor selecione o tipo de arquivo a ser importado"),
                            timer: 4000,
                            icon: 'error',
                            showConfirmButton: false
                        });

                        return;
                    }

                    if (!regimeSelecionado) {
                        Swal.fire({
                            text: t("Por favor selecione um regime tributário antes de selecionar um arquivo"),
                            timer: 4000,
                            icon: 'error',
                            showConfirmButton: false
                        });

                        return;
                    }

                    if (!plano) {
                        Swal.fire({
                            text: t("Por favor selecione um plano antes de selecionar um arquivo"),
                            timer: 4000,
                            icon: 'error',
                            showConfirmButton: false
                        });

                        return;
                    }

                    if (tipo === 'razao-padrao-participante' && !empresaSelecionada) {
                        Swal.fire({
                            text: t("Por favor selecione a empresa antes de importar o Razão Padrão Participante"),
                            timer: 4000,
                            icon: 'error',
                            showConfirmButton: false
                        });

                        return;
                    }

                    if (tipo === 'razao-winthor' && !empresaSelecionada) {
                        Swal.fire({
                            text: t("Por favor selecione a empresa antes de importar o Razão WinThor"),
                            timer: 4000,
                            icon: 'error',
                            showConfirmButton: false
                        });

                        return;
                    }

                    if (tipo === 'razao-winthor' && (!dataInicial || !dataFinal)) {
                        Swal.fire({
                            text: t("Por favor informe o período inicial e final antes de importar o Razão WinThor"),
                            timer: 4000,
                            icon: 'error',
                            showConfirmButton: false
                        });

                        return;
                    }

                    if (tipo === 'razao-protheus' && !empresaSelecionada) {
                        Swal.fire({
                            text: t("Por favor selecione a empresa antes de importar o Razão Protheus"),
                            timer: 4000,
                            icon: 'error',
                            showConfirmButton: false
                        });

                        return;
                    }

                    if (tipo === 'razao-protheus' && (!dataInicial || !dataFinal)) {
                        Swal.fire({
                            text: t("Por favor informe o período inicial e final antes de importar o Razão Protheus"),
                            timer: 4000,
                            icon: 'error',
                            showConfirmButton: false
                        });

                        return;
                    }

                    const input = document.getElementById("inputFile");
                    input?.click();
                }} className="col-md-12 mt-5" style={{ border: '2px dashed #8E92B8', textAlign: 'center', borderRadius: '10px', cursor: 'pointer', width: "100%" }}>
                    <div className="dropzone " id="upload" >
                        <div className="mt-5 mb-5">
                            {
                                validandoEcd ?
                                    <div style={{ width: '80%', margin: '0 auto' }}>
                                        <span className="spinner-border spinner-border-sm text-primary me-2"></span>
                                        <p className="mt-2 text-primary">{t("Validando arquivo ECD...")}</p>
                                    </div>
                                    :
                                lendoArquivo ?
                                    <div style={{ width: '80%', margin: '0 auto' }}>
                                        <div className="progress" style={{ height: '20px' }}>
                                            <div
                                                className="progress-bar progress-bar-striped progress-bar-animated"
                                                role="progressbar"
                                                style={{ width: `${uploadProgress}%` }}
                                                aria-valuenow={uploadProgress}
                                                aria-valuemin={0}
                                                aria-valuemax={100}
                                            >{uploadProgress}%</div>
                                        </div>
                                        <p className="mt-2 text-primary">{t("Fazendo upload do arquivo...")}</p>
                                    </div>
                                    :
                                    <>
                                        <i className="bi bi-cloud-arrow-up fs-5x azul-agriholmes" />
                                        <span className="azul-agriholmes" style={{ fontFamily: 'Cairo', fontSize: '1.875em' }}> <br />{t("Importar")} {tituloImportacao} <br /></span>

                                        <button className='btn btn-sm btn-primario' type='submit'>
                                            <span style={{ verticalAlign: 'middle' }}> {t('SELECIONE O ARQUIVO')} </span>
                                        </button>
                                    </>
                            }
                        </div>
                    </div>
                </div>
            </>

            <>
                <div className="card mt-10">
                    <div className="card-header border-0 pt-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label fw-bold fs-3 mb-1">{t("Histórico de Importações")}</span>
                            <span className="text-muted mt-1 fw-semibold fs-7">{t("Acompanhe o status dos seus arquivos")}</span>
                        </h3>
                    </div>
                    <div className="card-body py-3">
                        <div className="table-responsive">
                            <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                                <thead>
                                    <tr className="fw-bold text-muted">
                                        <th className="min-w-120px">{t("Arquivo")}</th>
                                        <th className="min-w-100px">{t("Data")}</th>
                                        <th className="min-w-100px">{t("Status")}</th>
                                        <th className="min-w-50px text-end">{t("Ações")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {uploads.map((upload) => (
                                        <tr key={upload.id}>
                                            <td style={upload.uploadPaiId ? { paddingLeft: '2rem' } : undefined}>
                                                <div className="d-flex align-items-center">
                                                    {upload.tipo === 'ecd-zip' && (
                                                        <i className="bi bi-file-zip fs-3 text-primary me-2" title={t("Lote de ECDs (.zip)")}></i>
                                                    )}
                                                    {upload.uploadPaiId && (
                                                        <i className="bi bi-arrow-return-right text-muted me-2" title={t("ECD dentro do .zip")}></i>
                                                    )}
                                                    <div className="d-flex flex-column">
                                                        <span className="text-dark fw-bold text-hover-primary fs-6">
                                                            {upload.nomeOriginal}
                                                        </span>
                                                        <span className="text-muted fw-semibold text-muted d-block fs-7">
                                                            ID: {upload.id}{upload.uploadPaiId ? ` · ${t("do lote")} #${upload.uploadPaiId}` : ''}
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <span className="text-muted fw-bold d-block fs-7">
                                                    {new Date(upload.dataCadastro).toLocaleString()}
                                                </span>
                                            </td>
                                            <td>
                                                {upload.arquivoProcessando && (
                                                    <span className="badge badge-light-primary fw-bold px-4 py-3">
                                                        <span className="spinner-border spinner-border-sm align-middle me-2"></span>
                                                        {t("Processando...")}
                                                    </span>
                                                )}
                                                {upload.arquivoProcessou && (
                                                    <span className="badge badge-light-success fw-bold px-4 py-3">
                                                        {t("Concluído")}
                                                    </span>
                                                )}
                                                {upload.arquivoErro && (
                                                    <span className="badge badge-light-danger fw-bold px-4 py-3">
                                                        {t("Erro no Processamento")}
                                                    </span>
                                                )}
                                            </td>
                                            <td className="text-end">
                                                <button
                                                    className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                                                    onClick={() => {
                                                        setUploadSelecionado(upload);
                                                        setShowStatusModal(true);
                                                    }}
                                                    title={t("Ver Status")}
                                                >
                                                    <i className="bi bi-info-circle fs-3"></i>
                                                </button>
                                                <button
                                                    className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                                                    onClick={() => handleDownload(upload)}
                                                    disabled={baixando === upload.id}
                                                    title={t("Baixar Arquivo")}
                                                >
                                                    {baixando === upload.id ? (
                                                        <span className="spinner-border spinner-border-sm"></span>
                                                    ) : (
                                                        <i className="bi bi-download fs-3"></i>
                                                    )}
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                    {uploads.length === 0 && !carregandoUploads && (
                                        <tr>
                                            <td colSpan={4} className="text-center text-muted py-10">
                                                {t("Nenhum arquivo importado recentemente")}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </>

            {/* Modal de Status */}
            <Modal show={showStatusModal} onHide={() => setShowStatusModal(false)} size="lg" centered>
                <div className="modal-header">
                    <h5 className="modal-title">
                        {t("Status do Processamento")} - {uploadSelecionado?.nomeOriginal}
                    </h5>
                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2" onClick={() => setShowStatusModal(false)}>
                        <i className="fas fa-times" style={{ color: '#5E6397' }}></i>
                    </div>
                </div>
                <Modal.Body>
                    <div className="d-flex justify-content-end mb-4">
                        <button 
                            className="btn btn-sm btn-light-primary" 
                            onClick={async () => {
                                if (uploadSelecionado) {
                                    const { data } = await api.get(`/upload/${uploadSelecionado.id}`);
                                    setUploadSelecionado(data);
                                }
                            }}
                        >
                                <i className="bi bi-arrow-clockwise me-2"></i>
                                {t("Atualizar")}
                            </button>
                        </div>
                        <div className="timeline-label">
                            {uploadSelecionado?.statuses && uploadSelecionado.statuses.length > 0 ? (
                                uploadSelecionado.statuses.map((status, index) => (
                                    <div key={status.id} className="timeline-item">
                                        <div className="timeline-label fw-bold text-gray-800 fs-6" style={{ width: 'auto', minWidth: '70px' }}>
                                            {new Date(status.dataMensagem).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
                                        </div>
                                        <div className="timeline-badge">
                                            <i className={`fa fa-genderless text-${status.type || 'primary'} fs-1`}></i>
                                        </div>
                                        <div className="fw-mormal timeline-content text-muted ps-3">
                                            {status.message}
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="text-center text-muted py-5">
                                    {t("Nenhuma mensagem de status disponível.")}
                                </div>
                            )}
                        </div>
                    </Modal.Body>
                <Modal.Footer>
                    <button 
                        type="button" 
                        className="btn btn-light" 
                        onClick={() => setShowStatusModal(false)}
                    >
                        {t("Fechar")}
                    </button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Validação do ECD */}
            <Modal show={showValidacaoModal} onHide={cancelarValidacaoEcd} size="lg" centered backdrop="static">
                <div className="modal-header">
                    <h5 className="modal-title">{resultadoValidacaoZip ? t("Validação do .zip de ECDs") : t("Validação do arquivo ECD")}</h5>
                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2" onClick={cancelarValidacaoEcd}>
                        <i className="fas fa-times" style={{ color: '#5E6397' }}></i>
                    </div>
                </div>
                <Modal.Body>
                    {resultadoValidacaoZip && (
                        <>
                            {resultadoValidacaoZip.valido ? (
                                <div className="alert alert-success d-flex align-items-center">
                                    <i className="bi bi-check-circle fs-2 me-3"></i>
                                    <div>{t("Os ECDs do .zip serão consolidados numa única esteira.")}</div>
                                </div>
                            ) : (
                                <div className="alert alert-danger d-flex align-items-center">
                                    <i className="bi bi-x-circle fs-2 me-3"></i>
                                    <div>{t("Foram encontrados problemas que impedem a importação deste .zip.")}</div>
                                </div>
                            )}

                            <div className="mb-4">
                                <label style={{ fontSize: '0.875em', color: '#aaa' }}>{t("Período consolidado")}</label>
                                <p className="fw-bold mb-0">
                                    {formatarDataResumo(resultadoValidacaoZip.periodoConsolidadoInicio)} {t("até")} {formatarDataResumo(resultadoValidacaoZip.periodoConsolidadoFim)}
                                    <span className="text-muted fw-normal"> — {resultadoValidacaoZip.arquivos.length} {t("ECD(s)")}</span>
                                </p>
                            </div>

                            {resultadoValidacaoZip.arquivos.length > 0 && (
                                <div className="table-responsive mb-4">
                                    <table className="table table-row-dashed table-row-gray-300 align-middle gy-2">
                                        <thead>
                                            <tr className="fw-bold text-muted fs-8">
                                                <th>{t("ECD")}</th>
                                                <th>{t("Período")}</th>
                                                <th className="text-end">{t("Contas")}</th>
                                                <th className="text-end">{t("Meses")}</th>
                                                <th>{t("Avisos")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {resultadoValidacaoZip.arquivos.map((arq, index) => (
                                                <tr key={index}>
                                                    <td className="fw-bold">{arq.nome}</td>
                                                    <td>{formatarDataResumo(arq.periodoInicio)} {t("a")} {formatarDataResumo(arq.periodoFim)}</td>
                                                    <td className="text-end">{arq.totalContas.toLocaleString('pt-BR')}</td>
                                                    <td className="text-end">{arq.totalMeses}</td>
                                                    <td className="text-warning fs-8">
                                                        {arq.avisos.length === 0 ? '—' : arq.avisos.map((a, i) => <div key={i}>{a.mensagem}</div>)}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}

                            {resultadoValidacaoZip.erros.length > 0 && (
                                <div className="mb-4">
                                    <h6 className="text-danger">{t("Erros")}</h6>
                                    <ul className="text-danger">
                                        {resultadoValidacaoZip.erros.map((erro, index) => (
                                            <li key={index}>{erro.mensagem}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </>
                    )}
                    {resultadoValidacao && (
                        <>
                            {resultadoValidacao.valido ? (
                                <div className="alert alert-success d-flex align-items-center">
                                    <i className="bi bi-check-circle fs-2 me-3"></i>
                                    <div>{t("Nenhum problema estrutural encontrado no arquivo.")}</div>
                                </div>
                            ) : (
                                <div className="alert alert-danger d-flex align-items-center">
                                    <i className="bi bi-x-circle fs-2 me-3"></i>
                                    <div>{t("Foram encontrados problemas que impedem a importação deste arquivo.")}</div>
                                </div>
                            )}

                            {resultadoValidacao.resumo && (
                                <div className="row mb-4">
                                    <div className="col-md-6">
                                        <label style={{ fontSize: '0.875em', color: '#aaa' }}>{t("Empresa identificada")}</label>
                                        <p className="fw-bold mb-2">{resultadoValidacao.resumo.razaoSocial || '-'} {resultadoValidacao.resumo.cnpj ? `(${resultadoValidacao.resumo.cnpj})` : ''}</p>
                                        <label style={{ fontSize: '0.875em', color: '#aaa' }}>{t("Período")}</label>
                                        <p className="fw-bold mb-2">{formatarDataResumo(resultadoValidacao.resumo.periodoInicio)} {t("até")} {formatarDataResumo(resultadoValidacao.resumo.periodoFim)}</p>
                                        <label style={{ fontSize: '0.875em', color: '#aaa' }}>{t("Tamanho do arquivo")}</label>
                                        <p className="fw-bold mb-2">{formatarTamanhoArquivo(resultadoValidacao.resumo.tamanhoArquivoBytes)} ({resultadoValidacao.resumo.totalLinhas.toLocaleString('pt-BR')} {t("linhas")})</p>
                                    </div>
                                    <div className="col-md-6">
                                        <label style={{ fontSize: '0.875em', color: '#aaa' }}>{t("Contas contábeis encontradas")}</label>
                                        <p className="fw-bold mb-2">{resultadoValidacao.resumo.totalContas.toLocaleString('pt-BR')}</p>
                                        <label style={{ fontSize: '0.875em', color: '#aaa' }}>{t("Meses com lançamentos")}</label>
                                        <p className="fw-bold mb-2">{resultadoValidacao.resumo.totalMeses}</p>
                                        <label style={{ fontSize: '0.875em', color: '#aaa' }}>{t("Tempo estimado de importação")}</label>
                                        <p className="fw-bold mb-2">
                                            {resultadoValidacao.tempoEstimado?.tempoEstimadoMs
                                                ? `~${formatarDuracao(resultadoValidacao.tempoEstimado.tempoEstimadoMs)}`
                                                : t("Sem histórico suficiente para estimar")}
                                            {resultadoValidacao.tempoEstimado && resultadoValidacao.tempoEstimado.amostraUtilizada > 0 && (
                                                <span className="text-muted fw-normal fs-8 d-block">
                                                    {t("baseado em")} {resultadoValidacao.tempoEstimado.amostraUtilizada} {t("importação(ões) anterior(es)")}
                                                    {resultadoValidacao.tempoEstimado.estimativaProporcionalAoTamanho ? ` — ${t("proporcional ao tamanho do arquivo")}` : ''}
                                                </span>
                                            )}
                                        </p>
                                    </div>
                                </div>
                            )}

                            {resultadoValidacao.erros.length > 0 && (
                                <div className="mb-4">
                                    <h6 className="text-danger">{t("Erros")}</h6>
                                    <ul className="text-danger">
                                        {resultadoValidacao.erros.map((erro, index) => (
                                            <li key={index}>{erro.mensagem}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                            {resultadoValidacao.avisos.length > 0 && (
                                <div className="mb-4">
                                    <h6 className="text-warning">{t("Avisos")}</h6>
                                    <ul className="text-warning">
                                        {resultadoValidacao.avisos.map((aviso, index) => (
                                            <li key={index}>{aviso.mensagem}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-light" onClick={cancelarValidacaoEcd} disabled={enviandoEcd}>
                        {t("Cancelar")}
                    </button>
                    {(resultadoValidacao?.valido || resultadoValidacaoZip?.valido) && (
                        <button type="button" className="btn btn-primario" onClick={confirmarImportacaoEcd} disabled={enviandoEcd}>
                            {enviandoEcd ? (
                                <span className="spinner-border spinner-border-sm me-2"></span>
                            ) : null}
                            {t("Prosseguir com a importação")}
                        </button>
                    )}
                </Modal.Footer>
            </Modal>
        </div >
    )
}

const Importar = () => {
    const [fazendoImportacao, setFazendoImportacao] = useState<boolean>(false);
    const { classes } = useLayout();
    const [empresa, setEmpresa] = useState<IEmpresas | null>(null);
    const [regimes, setRegimes] = useState<IRegimeTributario[]>([]);
    const [regimeSelecionado, setRegimeSelecionado] = useState<string>('');
    const [tituloImportacao] = useState<string>(steps[0].name);
    const [file, setFile] = useState<File>();
    const { t } = useTranslation();
    const [tipoArquivo, setTipoArquivo] = useState('');


    const getRegimesTributarios = useCallback(async () => {
        return await RegimeTributarioService.obterTodos();
    }, []);

    useEffect(() => {
        getRegimesTributarios().then((result: IRegimeTributario[]) => setRegimes(result));
    }, [getRegimesTributarios]);

    return <>
        <PageTitle breadcrumbs={[]}>{t('Importar ECD')}</PageTitle>
        <div className='toolbar' id='kt_toolbar'>
            <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}>
                <DefaultTitle />
            </div>
        </div>
        <div className="row">
            <div className="col-md-12" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className="col-md-8">
                    <div className="col-md-12">
                        <EmpresaCol empresa={empresa} regimes={regimes} regimeSelecionado={regimeSelecionado} setEmpresa={setEmpresa} />
                    </div>
                    <div className="row">
                        <ImportarECD setTipoArquivo={setTipoArquivo} empresa={empresa || null} regimes={regimes} regimeSelecionado={regimeSelecionado} setEmpresa={setEmpresa}
                            setFazendoImportacao={setFazendoImportacao} fazendoImportacao={fazendoImportacao} file={file || null}
                            setFile={setFile} setRegimeSelecionado={setRegimeSelecionado} tituloImportacao={tituloImportacao} />
                    </div>
                </div>
            </div>
        </div>
    </>
};


export default Importar;